/* WEAR THE FEAR — theme interactivity */
(function () {
  'use strict';

  /* ---------- Mobile nav ---------- */
  function initMobileNav() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!toggle || !nav) return;
    var close = nav.querySelector('[data-menu-close]');
    function open() { nav.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function shut() { nav.classList.remove('is-open'); document.body.style.overflow = ''; }
    toggle.addEventListener('click', open);
    if (close) close.addEventListener('click', shut);
    nav.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', shut); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') shut(); });
  }

  /* ---------- Product gallery ---------- */
  function initGallery() {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-gallery-main] img');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (main) { main.src = thumb.dataset.full || thumb.src; }
      });
    });
  }

  /* ---------- Variant selection ---------- */
  function initVariants() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;
    var variantsData = form.querySelector('[data-variants-json]');
    if (!variantsData) return;
    var variants;
    try { variants = JSON.parse(variantsData.textContent); } catch (e) { return; }

    var idInput = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-price-current]');
    var buyBtn = form.querySelector('[data-buy-button]');
    var optionGroups = Array.prototype.slice.call(form.querySelectorAll('[data-option-index]'));
    var routeParams = new URLSearchParams(window.location.search);
    optionGroups.forEach(function (group, index) {
      var retainedValue = routeParams.get('wtf-option-' + index);
      if (!retainedValue) return;
      var retainedPill = Array.prototype.slice.call(group.querySelectorAll('.variant-pill')).find(function (pill) {
        return pill.dataset.value === retainedValue;
      });
      if (retainedPill) {
        retainedPill.classList.add('is-active');
        retainedPill.setAttribute('aria-checked', 'true');
      }
    });
    if (routeParams.get('wtf-cut-confirmed') === '1') form.setAttribute('data-cut-confirmed', 'true');

    function selectedOptions() {
      return optionGroups.map(function (group) {
        var active = group.querySelector('.variant-pill.is-active:not([hidden])');
        return active ? active.dataset.value : null;
      });
    }

    function variantMatches(opts, index, value) {
      return variants.some(function (v) {
        if (v.options[index] !== value) return false;
        for (var i = 0; i < index; i++) {
          if (opts[i] !== null && v.options[i] !== opts[i]) return false;
        }
        return true;
      });
    }

    function ensureVisibleSelection(group) {
      var active = group.querySelector('.variant-pill.is-active');
      if (active && !active.hidden) return;
      if (active) {
        active.classList.remove('is-active');
        active.setAttribute('aria-checked', 'false');
      }
      var first = group.querySelector('.variant-pill:not([hidden])');
      if (first) {
        first.classList.add('is-active');
        first.setAttribute('aria-checked', 'true');
      }
    }

    function refreshAvailableOptions() {
      optionGroups.forEach(function (group, index) {
        var opts = selectedOptions();
        group.querySelectorAll('.variant-pill').forEach(function (pill) {
          var possible = variantMatches(opts, index, pill.dataset.value);
          pill.hidden = !possible;
          pill.disabled = !possible;
          pill.classList.toggle('is-unavailable', !possible);
          pill.setAttribute('aria-disabled', possible ? 'false' : 'true');
          if (!possible && pill.classList.contains('is-active')) {
            pill.classList.remove('is-active');
            pill.setAttribute('aria-checked', 'false');
          }
        });
      });
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return opts.every(function (o, i) { return o === null || v.options[i] === o; });
      });
    }

    function formatMoney(cents) {
      return (window.Shopify && window.Shopify.currency ? '' : '') +
        '$' + (cents / 100).toFixed(2);
    }

    function update() {
      refreshAvailableOptions();
      var opts = selectedOptions();
      var kind = form.getAttribute('data-product-kind') || '';
      var needsCut = ['Essential Tee', 'Oversized Tee', 'Long Line', 'Tank', 'Long Sleeve'].indexOf(kind) > -1;
      var status = form.querySelector('[data-choice-status]');
      if (form.getAttribute('data-image-cut-mismatch') === 'true') {
        if (buyBtn) { buyBtn.disabled = true; buyBtn.textContent = 'Unavailable'; }
        if (status) status.textContent = 'Unavailable while the correct product image is prepared.';
        return;
      }
      var missingIndex = opts.indexOf(null);
      if ((needsCut && form.getAttribute('data-cut-confirmed') !== 'true') || (kind !== 'Gym Towel' && missingIndex > -1)) {
        if (buyBtn) buyBtn.disabled = true;
        if (status) {
          status.textContent = needsCut && form.getAttribute('data-cut-confirmed') !== 'true'
            ? 'Choose cut'
            : 'Choose ' + (optionGroups[missingIndex].querySelector('.variant-group__label').textContent || 'option').trim().toLocaleLowerCase();
        }
        if (buyBtn) buyBtn.textContent = status ? status.textContent : 'Choose options';
        return;
      }
      var variant = findVariant(opts);
      if (!variant) {
        if (buyBtn) { buyBtn.disabled = true; buyBtn.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (buyBtn) {
        buyBtn.disabled = !variant.available;
        buyBtn.textContent = variant.available ? buyBtn.dataset.label || 'Add to cart' : 'Claimed';
      }
      if (status) status.textContent = '';
    }

    optionGroups.forEach(function (group) {
      group.querySelectorAll('.variant-pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          group.querySelectorAll('.variant-pill').forEach(function (p) {
            p.classList.remove('is-active'); p.setAttribute('aria-checked', 'false');
          });
          if (pill.hidden || pill.disabled) return;
          pill.classList.add('is-active'); pill.setAttribute('aria-checked', 'true');
          update();
        });
      });
    });
    document.addEventListener('wtf:cut-confirmed', function () {
      form.setAttribute('data-cut-confirmed', 'true');
      update();
    });
    update();
  }

  /* ---------- Newsletter graceful UX (Shopify handles real submit) ---------- */
  function initNewsletter() {
    document.querySelectorAll('[data-newsletter]').forEach(function (form) {
      // If Shopify returned a customer_posted=true param, show success.
      if (window.location.search.indexOf('customer_posted=true') > -1) {
        var note = form.querySelector('[data-newsletter-success]');
        if (note) note.hidden = false;
      }
    });
  }

  /* ---------- Black Market filters ---------- */
  function initBlackMarketFilters() {
    var filters = document.querySelector('[data-market-filters]');
    var grid = document.querySelector('[data-market-grid]');
    if (!filters || !grid) return;

    var buttons = Array.prototype.slice.call(filters.querySelectorAll('[data-filter]'));
    var items = Array.prototype.slice.call(grid.querySelectorAll('[data-market-item]'));
    var empty = document.querySelector('[data-market-empty]');

    function applyFilter(filter) {
      var shown = 0;
      items.forEach(function (item) {
        var categories = (item.getAttribute('data-category') || '').split(/\s+/);
        var visible = filter === 'all' || categories.indexOf(filter) > -1;
        item.hidden = !visible;
        if (visible) shown += 1;
      });
      buttons.forEach(function (button) {
        var active = button.getAttribute('data-filter') === filter;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (empty) {
        var isEmpty = shown === 0;
        empty.hidden = !isEmpty;
        empty.classList.toggle('is-visible', isEmpty);
      }
    }

    buttons.forEach(function (button) {
      button.setAttribute('aria-pressed', button.classList.contains('is-active') ? 'true' : 'false');
      button.addEventListener('click', function () {
        applyFilter(button.getAttribute('data-filter'));
      });
    });
    applyFilter('all');
  }

  /* ---------- Cart checkout agreement ---------- */
  function initCartPolicy() {
    document.querySelectorAll('[data-cart-policy]').forEach(function (policy) {
      var checkbox = policy.querySelector('[data-cart-policy-accept]');
      var checkoutButton = document.querySelector('[data-checkout-accept-target]');
      var hint = policy.querySelector('[data-cart-policy-hint]');
      if (!checkbox || !checkoutButton) return;

      function syncAgreement() {
        var accepted = checkbox.checked;
        checkoutButton.disabled = !accepted;
        checkoutButton.setAttribute('aria-disabled', accepted ? 'false' : 'true');
        if (hint) hint.classList.toggle('is-visible', !accepted);
      }

      checkbox.addEventListener('change', syncAgreement);
      syncAgreement();
    });
  }

  /* ---------- Size guide ---------- */
  function initSizeGuide() {
    document.querySelectorAll('[data-size-guide-toggle]').forEach(function (button) {
      var panel = button.closest('[data-size-guide-panel], [data-cart-policy]');
      if (!panel) return;
      button.addEventListener('click', function () {
        panel.classList.toggle('is-expanded');
        button.setAttribute('aria-expanded', panel.classList.contains('is-expanded') ? 'true' : 'false');
      });
    });

    var modal = document.querySelector('[data-size-guide-modal]');
    if (!modal) return;
    var openers = Array.prototype.slice.call(document.querySelectorAll('[data-size-guide-open]'));
    var closers = Array.prototype.slice.call(modal.querySelectorAll('[data-size-guide-close]'));

    function openModal() {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    openers.forEach(function (opener) {
      opener.addEventListener('click', openModal);
    });
    closers.forEach(function (closer) {
      closer.addEventListener('click', closeModal);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });
  }

  /* ---------- Limited Drops access ---------- */
  function unlockLimitedDrops(storageKey) {
    document.body.classList.add('limited-access-granted');
    document.querySelectorAll('[data-limited-product][data-product-url]').forEach(function (card) {
      card.setAttribute('href', card.getAttribute('data-product-url'));
    });
    document.querySelectorAll('[data-limited-gate]').forEach(function (root) {
      var locked = root.querySelector('[data-limited-locked]');
      var content = root.querySelector('[data-limited-content]');
      if (locked) locked.hidden = true;
      if (content) content.hidden = false;
    });
    initLimitedRedactions();
    try { window.localStorage.setItem(storageKey || 'wtf-limited-drops-access', 'unlocked'); } catch (e) {}
  }

  function initLimitedGate() {
    document.querySelectorAll('[data-limited-gate]').forEach(function (root) {
      if (root.dataset.limitedGateReady === 'true') return;
      root.dataset.limitedGateReady = 'true';

      var form = root.querySelector('[data-limited-form]');
      var input = root.querySelector('input[type="password"]');
      var error = root.querySelector('[data-limited-error]');
      var password = (root.getAttribute('data-password') || '').trim().toLowerCase();
      var storageKey = root.getAttribute('data-storage-key') || 'wtf-limited-drops-access';

      try {
        if (window.localStorage.getItem(storageKey) === 'unlocked') {
          unlockLimitedDrops(storageKey);
        }
      } catch (e) {}

      if (!form || !input) return;
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var attempt = input.value.trim().toLowerCase();
        if (attempt && attempt === password) {
          if (error) error.hidden = true;
          unlockLimitedDrops(storageKey);
        } else if (error) {
          error.hidden = false;
        }
      });
    });
  }

  function initLimitedRedactions() {
    document.querySelectorAll('.product-card--limited-locked').forEach(function (card) {
      if (card.dataset.redactionReady === 'true') return;
      card.dataset.redactionReady = 'true';

      function reveal() { card.classList.add('is-revealed'); }
      function redact() { card.classList.remove('is-revealed'); }

      card.addEventListener('mouseenter', reveal);
      card.addEventListener('mouseleave', redact);
      card.addEventListener('focus', reveal);
      card.addEventListener('blur', redact);
      card.addEventListener('touchstart', reveal, { passive: true });
    });
  }

  function initLimitedAccess() {
    var accessKey = 'wtf-limited-drops-access';
    var hasAccess = false;

    try {
      hasAccess = window.localStorage.getItem(accessKey) === 'unlocked';
    } catch (e) {
      hasAccess = false;
    }

    if (hasAccess) {
      unlockLimitedDrops(accessKey);
    }
  }

  /* ---------- Rotating skull backgrounds ---------- */
  function initSkullBackgrounds() {
    var skulls = window.WTF_SKULL_BACKGROUNDS || [];
    if (skulls.length === 0) return;

    var style = document.createElement('style');
    style.textContent = 'body::before { background-image: url("' + skulls[0] + '"); }';
    document.head.appendChild(style);

    var current = 0;
    var styleEl = document.head.querySelector('style:last-of-type');
    if (!styleEl) {
      styleEl = style;
    }

    function setSkull(index) {
      var img = new Image();
      img.onload = function () {
        if (styleEl) {
          styleEl.textContent = 'body::before { background-image: url("' + skulls[index] + '"); opacity: 0.06; }';
        }
      };
      img.src = skulls[index];
    }

    // Rotate every 30 seconds
    setSkull(0);
    setInterval(function () {
      current = (current + 1) % skulls.length;
      setSkull(current);
    }, 30000);
  }

  /* ---------- Randomize product grid items ---------- */
  function initProductShuffle() {
    var grids = document.querySelectorAll('.product-grid, .black-market__grid, [data-market-grid]');
    grids.forEach(function (grid) {
      var items = Array.prototype.slice.call(grid.children);
      // Fisher-Yates shuffle
      for (var i = items.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        grid.appendChild(items[j]);
      }
    });
  }

  /* ---------- Source-preserving design and cut routing ---------- */
  function normalizeDesign(value) {
    return String(value || '').trim().toLocaleLowerCase();
  }

  function cutFromProduct(product) {
    var sku = (product.variants || []).map(function (variant) { return variant.sku || ''; }).join(' ').toUpperCase();
    var cuts = [
      ['AS-COLOUR-5001', 'Essential Tee'], ['AS-COLOUR-5073', 'Long Line'],
      ['AS-COLOUR-5075', 'Tank'], ['AS-COLOUR-5101', 'Hoodie'],
      ['AS-COLOUR-5080', 'Oversized Tee'], ['AS-COLOUR-5029', 'Long Sleeve'],
      ['AS-COLOUR-1511', 'Gym Towel'], ['AS-COLOUR-3003', 'Baby Onesie']
    ];
    for (var i = 0; i < cuts.length; i += 1) {
      if (sku.indexOf(cuts[i][0]) !== -1) return cuts[i][1];
    }
    return 'Shop this cut';
  }

  function cutKey(product) {
    return cutFromProduct(product).toLocaleLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
  }

  function getProductsFromCollection(url) {
    var separator = url.indexOf('?') === -1 ? '?' : '&';
    return Promise.all([
      fetch(url, { credentials: 'same-origin' }).then(function (response) { return response.json(); }),
      fetch(url + separator + 'page=2', { credentials: 'same-origin' }).then(function (response) { return response.ok ? response.json() : { products: [] }; })
    ]).then(function (pages) {
      return (pages[0].products || []).concat(pages[1].products || []);
    });
  }

  function escapeHtml(value) {
    return String(value || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
  }

  function productImage(product) {
    if (product.featured_image && product.featured_image.src) return product.featured_image.src;
    if (product.images && product.images[0] && product.images[0].src) return product.images[0].src;
    return '';
  }

  function initPrimaryCategoryLinks() {
    var routes = {
      'the black market': '/collections/all',
      'shirts': '/collections/shirts',
      'accessories': '/collections/all?category=accessories',
      'kids clothes': '/collections/all?category=kids-clothes'
    };
    document.querySelectorAll('.site-header__nav a, .mobile-nav a').forEach(function (link) {
      var route = routes[String(link.textContent || '').trim().toLocaleLowerCase()];
      if (route) link.setAttribute('href', route);
    });
  }

  function initDesignGrid() {
    var grid = document.querySelector('[data-design-grid]');
    if (!grid || !window.fetch) return;
    var url = grid.getAttribute('data-products-json-url');
    if (!url) return;
    var params = new URLSearchParams(window.location.search);
    var requestedCut = params.get('cut') || 'all';
    var requestedCategory = params.get('category') || '';
    if (params.get('market') === 'landing') {
      var hero = document.querySelector('.black-market__hero');
      var filters = document.querySelector('.black-market__filters');
      var sectionHead = grid.closest('.section').querySelector('.section-head');
      if (hero) hero.style.display = 'none';
      if (filters) filters.style.display = 'none';
      if (sectionHead) sectionHead.style.display = 'none';
      var cards = [
        ['shirts', 'Shirts', grid.getAttribute('data-black-market-apparel-image'), grid.getAttribute('data-black-market-shirts-video')],
        ['accessories', 'Accessories', grid.getAttribute('data-black-market-extra-gear-image'), grid.getAttribute('data-black-market-accessories-video')],
        ['kids-clothes', 'Kids Clothes', grid.getAttribute('data-black-market-little-screamers-image'), grid.getAttribute('data-black-market-kids-video')]
      ];
      grid.className = 'black-market-landing__grid';
      grid.innerHTML = cards.map(function (card) {
        return '<a class="black-market-category-card" href="' + escapeHtml(window.location.pathname) + '?category=' + card[0] + '" aria-label="Shop ' + card[1] + '">' +
          '<span class="black-market-category-card__media" aria-hidden="true">' +
          '<img src="' + escapeHtml(card[2]) + '" alt="" width="1024" height="1536">' +
          '<video autoplay muted loop playsinline preload="metadata" poster="' + escapeHtml(card[2]) + '"><source src="' + escapeHtml(card[3]) + '" type="video/mp4"></video></span>' +
          '<span class="black-market-category-card__title">' + escapeHtml(card[1]) + '</span></a>';
      }).join('');
      var landingPagination = document.querySelector('[data-design-pagination]');
      if (landingPagination) landingPagination.style.display = 'none';
      return;
    }
    if (requestedCategory) {
      var filterNav = document.querySelector('.black-market__filters');
      if (filterNav) filterNav.hidden = true;
    }
    document.querySelectorAll('[data-cut-filter]').forEach(function (filter) {
      var active = filter.getAttribute('data-cut-filter') === requestedCut;
      filter.classList.toggle('is-active', active);
      filter.setAttribute('aria-current', active ? 'page' : 'false');
    });
    getProductsFromCollection(url).then(function (products) {
      var categoryCuts = {
        'shirts': ['Essential Tee', 'Oversized Tee', 'Long Line', 'Tank', 'Long Sleeve'],
        'accessories': ['Gym Towel'],
        'kids-clothes': ['Baby Onesie']
      };
      if (requestedCategory && categoryCuts[requestedCategory]) {
        products = products.filter(function (product) {
          return categoryCuts[requestedCategory].indexOf(cutFromProduct(product)) > -1;
        });
      }
      if (requestedCut !== 'all') {
        products = products.filter(function (product) { return cutKey(product) === requestedCut; });
      }
      var priority = { 'Essential Tee': 0, 'Oversized Tee': 1, 'Long Line': 2, 'Tank': 3, 'Long Sleeve': 4 };
      products.sort(function (left, right) {
        var leftPriority = priority[cutFromProduct(left)];
        var rightPriority = priority[cutFromProduct(right)];
        return (leftPriority === undefined ? 99 : leftPriority) - (rightPriority === undefined ? 99 : rightPriority);
      });
      var seen = {};
      var designs = products.filter(function (product) {
        var key = normalizeDesign(product.title);
        if (!key || seen[key]) return false;
        seen[key] = true;
        return true;
      });
      if (!designs.length) return;
      grid.innerHTML = designs.map(function (product) {
        var image = productImage(product);
        var imageMarkup = image ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '" width="600" height="750" loading="lazy">' : '';
        return '<a href="/products/' + encodeURIComponent(product.handle) + '" class="product-card product-card--design" aria-label="Shop ' + escapeHtml(product.title) + '">' +
          '<div class="product-card__media">' + imageMarkup + '</div></a>';
      }).join('');
      var pagination = document.querySelector('[data-design-pagination]');
      if (pagination) pagination.hidden = true;
    }).catch(function () {
      // Keep Shopify's server-rendered source-product cards as the fallback.
    });
  }

  function initProductCutRouter() {
    var router = document.querySelector('[data-product-cut-router]');
    if (!router || !window.fetch) return;
    var title = normalizeDesign(router.getAttribute('data-design-title'));
    var currentHandle = router.getAttribute('data-current-product-handle');
    var status = router.querySelector('[data-cut-router-status]');
    var options = router.querySelector('[data-cut-router-options]');
    var customerCutOrder = ['Essential Tee', 'Oversized Tee', 'Long Line', 'Tank', 'Long Sleeve'];
    // Audit 2026-08-03: Print Bar source previews for these cuts show the
    // wrong garment. Hiding the fault would risk sending a customer the wrong
    // fulfilment SKU, so keep them visibly unavailable until replacement
    // sources have been independently verified.
    var imageMismatchCuts = { 'Long Line': true, 'Tank': true };
    if (!title || !options) return;
    getProductsFromCollection('/collections/all/products.json?limit=250').then(function (products) {
      var siblings = products.filter(function (product) { return normalizeDesign(product.title) === title; });
      if (!siblings.length) return;
      options.innerHTML = customerCutOrder.map(function (cut) {
        var product = siblings.find(function (candidate) { return cutFromProduct(candidate) === cut; });
        var label = escapeHtml(cut);
        if (!product || imageMismatchCuts[cut]) {
          return '<button type="button" class="variant-pill is-unavailable" disabled aria-disabled="true">' + label + ' — Unavailable</button>';
        }
        var preview = escapeHtml(productImage(product));
        return product.handle === currentHandle
          ? '<button type="button" class="variant-pill" data-cut-confirm aria-pressed="false">' + label + '</button>'
          : '<a class="variant-pill" data-cut-preview="' + preview + '" href="/products/' + encodeURIComponent(product.handle) + '">' + label + '</a>';
      }).join('');
      options.hidden = false;
      if (status) status.hidden = true;
      options.querySelectorAll('[data-cut-confirm]').forEach(function (cutButton) {
        cutButton.addEventListener('click', function () {
          cutButton.classList.add('is-active');
          cutButton.setAttribute('aria-pressed', 'true');
          document.dispatchEvent(new CustomEvent('wtf:cut-confirmed'));
        });
      });
      options.querySelectorAll('[data-cut-preview]').forEach(function (cutLink) {
        cutLink.addEventListener('click', function () {
          var form = document.querySelector('[data-product-form]');
          if (!form) return;
          var params = new URLSearchParams();
          params.set('wtf-cut-confirmed', '1');
          form.querySelectorAll('[data-option-index]').forEach(function (group, index) {
            var active = group.querySelector('.variant-pill.is-active:not([hidden])');
            if (active) params.set('wtf-option-' + index, active.dataset.value);
          });
          cutLink.href += '?' + params.toString();
        });
      });
    }).catch(function () {
      if (status) status.textContent = 'Choose a size and colour for this cut.';
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    // Old header/home links may still be cached in a visitor's browser or an
    // earlier theme section. Never leave a customer on the retired collection.
    if (window.location.pathname === '/collections/limited-drops') {
      window.location.replace('/collections/all');
      return;
    }
    initPrimaryCategoryLinks();
    initLimitedAccess();
    initLimitedGate();
    initLimitedRedactions();
    initMobileNav();
    initGallery();
    initVariants();
    initNewsletter();
    initBlackMarketFilters();
    initCartPolicy();
    initSizeGuide();
    initSkullBackgrounds();
    initProductShuffle();
    initDesignGrid();
    initProductCutRouter();
  });
})();
